import { StateVariable } from '@akin-home/state-variables';
import { updateStateVariables } from '@akin-home/state-variables-frontend';
import { useMutation, useQueryClient } from 'react-query';

export const useUpdateStateVariables = () => {
  const query_client = useQueryClient();

  return useMutation(updateStateVariables, {
    onSuccess(data, variables) {
      const { username, application_id } = variables;

      const state_variables = data.data?.state_variables;

      if (state_variables) {
        query_client.setQueriesData(
          ['state_variables', 'list', username, application_id],
          (old_data: StateVariable[] | undefined) => {
            return (
              old_data?.map((v) => {
                return state_variables?.find((o) => o.id === v.id) || v;
              }) || []
            );
          }
        );

        query_client.setQueriesData(
          ['state_variables', 'detail', username, application_id],
          (old_data: StateVariable[] | undefined) => {
            return (
              old_data?.map((v) => {
                return state_variables?.find((o) => o.id === v.id) || v;
              }) || []
            );
          }
        );
      }
    },
  });
};
